export default __webpack_public_path__ + "static/media/expl-gradcam_01_EN.b125528a.png";